// src/utils/sanitize.js
// Centralised HTML sanitization for any content rendered via
// dangerouslySetInnerHTML (e.g. Shopify product body_html).
// Prevents XSS by stripping scripts, event handlers, javascript: URLs, etc.,
import DOMPurify from "dompurify";

export function sanitizeHtml(dirtyHtml) {
  if (!dirtyHtml) return "";
  return DOMPurify.sanitize(String(dirtyHtml));
}